<template>
<div class="container">
    <div class="wahlzettel">
        <br />
        <p class="lead">In Österreich sind alle Parteien für elektronische Unterstützungserklärungen, dennoch gibt es sie nicht. Obwohl mal zB. Volksbegehren digital unterschreiben kann, müssen Kleinparteien wie wir mindestens 2600 Unterstützungserklärungen binnen weniger Wochen sammeln - in jedem Bundesland, am Hauptwohnsitz, vor einem Beamten, zu regulären Öffnungszeiten. Das ist pure Schikane und verhindert den bloßen Wahlantritt von Parteien, die wirklich im Bürgerauftrag und nicht im Auftrag von Großspendern Politik machen wollen.</p>
        <p class="lead">Wir zeigen Dir hier, wie einfach es gehen könnte, Deiner Lieblingspartei elektronisch den Wahlantritt zu ermöglichen.</p>
    </div>
    <a href="https://www.piratenpartei.at/" target="_blank"><img class="d-block mx-auto" src="@/assets/logo.png" alt="" width="283" height="130"></a>
    <div class="py-5 text-center">
        <p>&copy; 2019 <a href="https://www.piratenpartei.at/" class="text-muted">Piratenpartei Österreichs</a> - <a href="https://www.piratenpartei.at/rechtliches/impressum/" class="text-muted">Impressum</a></p>
    </div>
</div>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style>
    .wahlzettel {
        text-align: center;
    }
</style>
